import React from "react";

//Styles
import "./Input.scss";

const Input = ({
    className = "",
    text,
    name,
    value,
    type = "text",
    placeholder,
    onChange,
    onKeyDown,
    required,
    icon,
    id,
    ref,
    show,
}) => {
    return (
        <div className={`Input ${className}`}>
            {text && <span className="title-input">{text}</span>}
            <div
                className={`container-input ${
                    type === "date" ? "classDate" : ""
                }`}
            >
                {icon && (
                    <div className="cnt-img">
                        <img src={icon} alt="" className="icon-in" />
                    </div>
                )}
                <input
                    className={`cs-input ${icon ? "none-border" : ""} ${
                        show ? "error-color" : ""
                    }`}
                    type={type}
                    ref={ref}
                    id={id}
                    name={name}
                    value={value}
                    placeholder={placeholder}
                    onChange={onChange}
                    required={required}
                    onKeyDown={onKeyDown}
                />
            </div>
        </div>
    );
};
export default Input;
